/**
 * @namespace
 * @param  {} aCreateMethod
 */
var VeritracksThreadsControl = function (aCreateMethod) {
    var mThreadsURL = '';
    var mData = [];
    var createGraphMethod = aCreateMethod;
    this.displayGraph = function (aGraphId) {
        return mThreadsURL + '/' + aGraphId + '?/userToken=';
    }

    this.buildGraph = function (aMaster, aNodes, aAssociations) {
        var lGraph = new Graph();

        lGraph.MasterNode = aMaster;
        lGraph.Nodes = aNodes;
        lGraph.Associations = aAssociations;

        // circular to json clean up.
        return JSON.stringify(lGraph);
    }

    this.setData = function(aName, aData){
        mData[aName] = aData;
    }

    this.getData = function (aName) {
        if(aName)
            return mData[aName];

        return mData;
    }

    this.CreateGraph = function (aGraph, aCallback) {
        mData = []; // clear data;
        createGraphMethod(aGraph, [], aCallback);
    }
}
